export const purchaseRoutes = [
    {
        path: '/purchase',
        meta: { requiresHousehold: true },
        children: [
          {
            path: '',
            redirect: '/purchase/shopping-lists',
          },
          {
            path: 'shopping-lists',
            component: () => import(/* webpackChunkName: "purchase" */ '@/features/purchase/views/PurchaseShoppingLists.vue'),
          },
          {
            path: 'shopping-list-templates',
            component: () => import(/* webpackChunkName: "purchase" */ '@/features/purchase/views/PurchaseShoppingListTemplates.vue'),
          },
          {
            path: 'wish-lists',
            component: () => import(/* webpackChunkName: "purchase" */ '@/features/purchase/views/PurchaseWishLists.vue'),
          }
        ]
    }
]
